<div class="change-receiver-dialog">
  <div class="dialog-header">
    <div style="display: flex; align-items: center; gap: 10px;">
      <div class="header-icon-box">
        <mat-icon style="color: #0284c7; font-size: 24px; width: 24px; height: 24px;">person_pin</mat-icon>
      </div>
      <div>
        <h2 style="margin: 0; font-size: 18px; font-weight: 700; color: #0f172a;">Modifier le Destinataire</h2>
        <div *ngIf="ticketNumber" style="font-size: 12px; color: #64748b; margin-top: 2px;">
          Colis : <strong>{{ ticketNumber }}</strong>
        </div>
      </div>
    </div>
    <button mat-icon-button (click)="onCancel()" title="Fermer" style="color: #64748b;">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content style="overflow: visible !important; max-height: none !important; padding: 18px 0 8px 0; margin: 0;">
    <form [formGroup]="receiverForm">
      <div class="inputs-row" style="display: flex !important; flex-direction: row !important; flex-wrap: nowrap !important; gap: 16px !important; align-items: center !important; width: 100% !important; box-sizing: border-box !important;">
        
        <!-- Phone Number Field (BEFORE Name) -->
        <mat-form-field appearance="outline" style="flex: 1 1 50% !important; min-width: 0 !important; margin-bottom: 0 !important;">
          <mat-label>Nouveau Téléphone</mat-label>
          <input 
            matInput 
            formControlName="receivernumber" 
            placeholder="Ex: 699000000" 
            required 
            autocomplete="off"
            (keyup)="onPhoneKeyup($event)"
            [matAutocomplete]="autoPhone"
          >
          <mat-spinner *ngIf="isSearchingPhone" matSuffix diameter="18" style="margin-right: 6px;"></mat-spinner>
          <mat-icon *ngIf="!isSearchingPhone" matSuffix style="color: #64748b;">phone</mat-icon>

          <mat-autocomplete #autoPhone="matAutocomplete">
            <mat-option 
              *ngFor="let opt of phoneSearchResults" 
              [value]="opt.phone" 
              (onSelectionChange)="$event.isUserInput && onSelectPhoneOption(opt)"
            >
              <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; gap: 12px;">
                <span style="font-weight: 600; color: #0284c7;">{{ opt.phone }}</span>
                <span *ngIf="opt.name" style="color: #64748b; font-size: 13px; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{ opt.name }}
                </span>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <!-- Receiver Name Field (AFTER Phone) -->
        <mat-form-field appearance="outline" style="flex: 1 1 50% !important; min-width: 0 !important; margin-bottom: 0 !important;">
          <mat-label>Nouveau Nom du Destinataire</mat-label>
          <input 
            matInput 
            formControlName="receivername" 
            placeholder="Nom et prénom" 
            required 
            autocomplete="off"
            (keyup)="onNameKeyup($event)"
            [matAutocomplete]="autoName"
          >
          <mat-spinner *ngIf="isSearchingName" matSuffix diameter="18" style="margin-right: 6px;"></mat-spinner>
          <mat-icon *ngIf="!isSearchingName" matSuffix style="color: #64748b;">person</mat-icon>

          <mat-autocomplete #autoName="matAutocomplete">
            <mat-option 
              *ngFor="let opt of nameSearchResults" 
              [value]="opt.name" 
              (onSelectionChange)="$event.isUserInput && onSelectNameOption(opt)"
            >
              <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; gap: 12px;">
                <span style="font-weight: 600; color: #0f172a;">{{ opt.name }}</span>
                <span *ngIf="opt.phone" style="color: #0284c7; font-size: 13px; max-width: 120px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{ opt.phone }}
                </span>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end" style="margin: 16px 0 0 0; padding: 12px 0 0 0; border-top: 1px solid #e2e8f0; display: flex; justify-content: flex-end; gap: 10px;">
    <button mat-button (click)="onCancel()" [disabled]="isSubmitting" style="border-radius: 6px;">Annuler</button>
    <button mat-raised-button color="primary" [disabled]="receiverForm.invalid || isSubmitting" (click)="onSubmit()" style="border-radius: 6px; font-weight: 600; padding: 0 20px;">
      <mat-icon *ngIf="!isSubmitting">save</mat-icon>
      <mat-spinner *ngIf="isSubmitting" diameter="18" style="display: inline-block; vertical-align: middle; margin-right: 6px;"></mat-spinner>
      <span>Enregistrer</span>
    </button>
  </mat-dialog-actions>
</div>
